import { Avatar, Badge, Tooltip, Typography } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'

import { useStyles } from '../styles'

interface IAccountBadgedIconProps {
  alt: string
  src: string
  isOwner: boolean
}

const AccountBadgedIcon = ({ alt, src, isOwner }: IAccountBadgedIconProps) => {
  const classes = useStyles()

  return (
    <Tooltip
      title={
        <div>
          <Typography className={classes.title} variant="body1">
            {alt}
          </Typography>
          {isOwner && (
            <Typography className={classes.subtitle} variant="caption">
              <HelperWrapper ns={ETranslationNs.Users} t="account-owner-tooltip-caption" />
            </Typography>
          )}
        </div>
      }
    >
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        variant="dot"
        className={isOwner ? classes.ownerCircle : undefined}
      >
        <Avatar variant="circular" className={classes.selectionAvatar} alt={alt} src={src} />
      </Badge>
    </Tooltip>
  )
}

export { AccountBadgedIcon }
